import { useState } from 'react';

import { useSchedulerServerClient } from '../useSchedulerServerClient'
import { useServerParams } from '../useServerParams';

// export const groupTypes = {
//     supplier: "supplier",
//     customer: "customer",
//     administrator: "administrator"
// }

// export const targetTypes = {
//     supplier: "supplier",
//     customer: "customer",
//     administrator: "administrator"
// }

// export const scopeTypes = {
//     administrator: [
//         {
//             id: "access_route",
//             name: "Access Route",
//             isDefault: true
//         }
//     ],
//     customer: [
//         {
//             id: "group_price",
//             name: "Group Price",
//             isDefault: true
//         },
//         {
//             id: "delivery_remark",
//             name: "Delivery Remark",
//             isDefault: false
//         },
//         {
//             id: "logistic_rate",
//             name: "Logistic Rate",
//             isDefault: false
//         }
//     ],
//     supplier: [
//         {
//             id: "default",
//             name: "Default",
//             isDefault: true
//         }
//     ]
// }

export function useSchedulerServer({
    serverConfig
}) {

    const baseUrl = serverConfig?.url

    // const [groupType, setScopeType] = useState(_groupType);
    // const [targetType, setTargetType] = useState(_targetType);

    const { makeCall } = useSchedulerServerClient({
        baseUrl
    });

    // const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    // const endpoint1 = "group";
    // const endpoint2 = "groups"

    const listRunningTasks = async () => {

        setIsLoading(true);

        try {

            let url = `allRunningTasks`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const listStopTasks = async () => {

        setIsLoading(true);

        try {

            let url = `allStopTasks`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const stopById = async ({ idArray = [] }) => {

        setIsLoading(true);

        try {

            let url = `stopById?id=${JSON.stringify(idArray)}`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const startById = async ({ idArray = [] }) => {

        setIsLoading(true);

        try {

            let url = `startById?id=${JSON.stringify(idArray)}`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const addTasks = async ({ idArray = [] }) => {

        setIsLoading(true);

        try {

            let url = `addTasks?id=${JSON.stringify(idArray)}`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }


    return {
        isLoading,
        // filterOperatorTypes,
        // groupTypes,
        // targetTypes,
        listRunningTasks,
        listStopTasks,
        stopById,
        startById,
        addTasks
    }
}